export default "__VITE_ASSET__851de87a__"